import PricingOne from "./PricingOne";

export default PricingOne
